import {
  Box, Card, CardContent, Typography,
} from '@mui/material';

interface DataBoxProps {
  title: string;
  value: number;
}

export const DataCard = ({ title, value }: DataBoxProps) => (
  <Card sx={{ border: '1px solid #ccc' }} elevation={0}>
    <CardContent>
      <Typography component="div" color="text.secondary">
        {title}
      </Typography>
      <Box sx={{
        display: 'flex', flex: '1', justifyContent: 'center', alignItems: 'center', height: '100%', marginTop: '0.5rem',
      }}
      >
        <Typography variant="h6">
          {value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);
